module.exports = __webpack_public_path__ + "static/intro_book-8e169e76e913b5c9e6dcee35e97d9ee2.jpg";